// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const config = {
  apiKey: window?.getTheLook?.apiKey,
  apiHost: window?._QONizer?.domains?.restApiDomain || 'restapiv3.quarticon.com',
  customerSymbol: window?.getTheLook?.customerSymbol,
  searchId: window?.getTheLook?.searchId,
  catalogId: window?.getTheLook?.catalogId,
  stylistInstanceId: window?.getTheLook?.stylistInstanceId,
  listingUrl: window?.getTheLook?.listingUrl || '/',
  getTheLookUrl: window?.getTheLook?.getTheLookUrl || '/',
  useHashBeforeParams: typeof window?.getTheLook?.useHashBeforeParams !== 'undefined' ? window?.getTheLook?.useHashBeforeParams : true
}
